module.exports = __webpack_public_path__ + "static/nori-sig-9ce43345bb624b14860400efcf823000.svg";